
export enum TmcWarningAction {
    TRADE_SINGLES,
    TRADE_TMC
}
